import React, {
  useCallback,
  useEffect,
} from 'react';
import isNil from 'lodash/isNil';
import {
  FieldValues,
  useFormContext,
} from 'react-hook-form';
import {
  FilterProps,
} from 'core/Filters/types';
import {
  getFilterInitialValues,
  serializeFilterQuery,
} from 'core/Filters/util';
import FilterComponents from 'core/Filters/FilterComponents';

export default function FilterForm(
  {
    instanceRef,
    components,
    defaultValues,
    fieldClassNameRules,
    dateRangeProps,
  }: FilterProps,
) {
  const {
    watch,
    reset,
    formState: { errors, dirtyFields },
  } = useFormContext<FieldValues>();

  const filters = watch();
  const clearAll = useCallback(() => {
    const initialValues = getFilterInitialValues(filters, components);
    reset(
      initialValues,
      { keepDirty: false, keepTouched: false },
    );
  }, [components, filters, reset]);

  const getFilterQuery = useCallback(
    () => serializeFilterQuery(filters, components),
    [components, filters],
  );

  useEffect(() => {
    if (!isNil(instanceRef)) {
      instanceRef.current = {
        clearAll,
        filterRawData: filters,
        getFilterQuery,
        errors,
        dirtyFields,
      };
    }
  }, [filters]);

  return (
    <FilterComponents
      components={components}
      defaultValues={defaultValues}
      fieldClassNameRules={fieldClassNameRules}
      dateRangeProps={dateRangeProps}
    />
  );
}
